import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { config } from '~/constants/config';
import classNames from 'classnames';
import Panel from '@/Panel';
import ToggleButton from '@/ToggleButton';

@inject("panelStore") @observer 
export default class Billy extends Component {
  constructor(props){
    super(props)
  }
  render() {
    let { panelStatus } = this.props.panelStore;
    let billyClass = classNames(config.BILLY_CLASSNAME, {
      'billy_active': panelStatus.isToggleOn,
      'billy_resize': panelStatus.isResizeOn
    })
    return (
      <div className={ billyClass }>
        <ToggleButton />
        <Panel />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Billy/index.js